import { Component, HostListener } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { I18nServiceService } from './shared/shared-services/i18n-service/i18n-service.service';
import { ActivatedRoute } from '@angular/router';
import { routeTransition } from './shared/components/route-animations';
import { CommonSharedServiceService } from './shared/shared-services/common-shared-service/common-shared-service.service';
import { LocalStorageService } from './shared/services/local-storage/local-storage.service';
import { UtilitiesService } from './shared/services/utilities/utilities.service';
import { environment } from 'src/environments/environment';
import { NotificationService } from './shared/services/notification/notification.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  animations: [routeTransition],
})
export class AppComponent {
  constructor(
    private readonly translate: TranslateService,
    private i18nService: I18nServiceService,
    protected route: ActivatedRoute,
    private commonSharedService: CommonSharedServiceService,
    private readonly localStorageService: LocalStorageService,
    private readonly utilitiesService: UtilitiesService,
    private readonly notificationService: NotificationService
  ) {
    this.translate.setDefaultLang('en');
    this.translate.use('en');
  }

  public changeLanguage(language: string): void {
    this.i18nService.changeLanguage(language);
  }
  title = 'Shohay';

  ngOnInit(): void {
    if (environment.envName === 'stage') {
      const sessionUser = this.localStorageService.getSessionUser();
      if (!sessionUser) {
        const hasVisited = localStorage.getItem('hasVisited');

        if (!hasVisited) {
          console.log('First-time visitor. Showing popup.');
          this.commonSharedService.updateDemoPopupState(true);

          localStorage.setItem('hasVisited', 'true'); // Store flag so it doesn't show again
        } else {
          this.commonSharedService.updateDemoPopupState(false);
        }
      }
    }
    // if (!this.localStorageService.getIsNotificationRegistered()) {
      this.notificationService.listenFromFireBaseServer();
    // }
  }

  @HostListener('window:beforeunload', ['$event'])
  onBeforeUnload(event: Event): void {
    console.log('User is leaving the website. Clearing hasVisited.');
    localStorage.removeItem('hasVisited');
  }

  ngOnDestroy(): void {
    localStorage.removeItem('hasVisited'); // Extra safety in case component is destroyed
  }
}
